import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { CreatePromocodeBatchModal, EditPromocodeBatchModal, PromocodeBatchListFilters } from "@modules/promocodeBatches/components";

import { usePromocodeBatchList } from "./controller";
import { usePromocodeBatchListColumns } from "./columns";

export const PromocodeBatchList = React.memo(() => {
  const {
    rows,
    loading,
    agreements,
    selectedRows,
    dataToExport,
    createPromocodeBatchModalRef,
    editPromocodeBatchModalRef,
    setSelectedRows,
    refetch,
    translate,
    tableProps,
  } =  usePromocodeBatchList();

  const columns = usePromocodeBatchListColumns(
    refetch,
    translate,
    editPromocodeBatchModalRef,
    agreements
  );

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <PromocodeBatchListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="promocodebatchs.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton onClick={() => createPromocodeBatchModalRef.current?.open()} />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreatePromocodeBatchModal
        modalRef={createPromocodeBatchModalRef}
        onComplete={refetch}
      />
      <EditPromocodeBatchModal
        modalRef={editPromocodeBatchModalRef}
        onComplete={refetch}
      />
    </List>
  );
});
